import { Tags, User, Users, Megaphone, Trophy } from 'lucide-react';
import { Skeleton } from "@/ui-components/ui/skeleton";
import { DialogTagsSection } from "@/util-components/dialog/base-dialogs/dialog-sections";

interface MentionedEntity {
  type: string;
  id: string;
  name?: string;
  thumbnailUrl?: string | null;
}

interface MentionedEntitiesListProps {
  entities: MentionedEntity[];
  isLoading?: boolean;
}

export const MentionedEntitiesList = ({ entities, isLoading }: MentionedEntitiesListProps) => {
  if (isLoading) {
    return (
      <div className="pt-2">
        <DialogTagsSection title="Markierungen" icon={Tags}>
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center gap-2.5 p-1.5 pr-4 bg-gray-50/80 border border-gray-200/60 rounded-full shadow-sm w-32 h-10">
              <Skeleton className="w-7 h-7 rounded-full shrink-0" />
              <Skeleton className="h-3.5 w-full rounded" />
            </div>
          ))}
        </DialogTagsSection>
      </div>
    );
  }

  if (!entities || entities.length === 0) return null;


  return (
    <div className="pt-2">
      <DialogTagsSection title="Markierungen" icon={Tags}>
        {entities.map((entity, i) => {
          const getIcon = () => {
            if (entity.type === 'Player') return <User className="w-3.5 h-3.5 text-gray-400" />;
            if (entity.type === 'Team') return <Users className="w-3.5 h-3.5 text-gray-400" />;
            if (entity.type === 'Sponsor') return <Megaphone className="w-3.5 h-3.5 text-gray-400" />;
            if (entity.type === 'Match') return <Trophy className="w-3.5 h-3.5 text-gray-400" />;
            return <Tags className="w-3.5 h-3.5 text-gray-400" />;
          };
          
          return (
            <div key={i} className="flex items-center gap-2.5 p-1.5 pr-4 bg-gray-50/80 hover:bg-gray-100 transition-colors border border-gray-200/60 rounded-full shadow-sm">
              <div className="w-7 h-7 rounded-full bg-white border border-gray-200 flex items-center justify-center overflow-hidden shrink-0 shadow-inner">
                {entity.thumbnailUrl ? (
                  <img src={entity.thumbnailUrl} alt={entity.name || "Entity thumbnail"} className="w-full h-full object-cover" />
                ) : (
                  getIcon()
                )}
              </div>
              <span className="text-xs font-bold text-gray-700">{entity.name || "Unbekannt"}</span>
            </div>
          );
        })}
      </DialogTagsSection>
    </div>
  );
};
